import React, { useState } from "react";
import moment from 'moment';
import $ from 'jquery';
import { DatePicker } from 'antd';
import WeatherReport from "../components/modals/WeatherReport";
import HumanPowerReport from "../components/modals/HumanPowerReport";
import StandardDailyReport from "../components/modals/StandardDailyReport";
import EnvironmentalReport from "../components/modals/EnvironmentalReport";
import AfterHoursVisitorsReport from "../components/modals/AfterHoursVisitorsReport";
// import VehicleTrackingReport from "../components/modals/VehicleTrackingReport";
import Tiles from "./tiles";
import Modal from "../components/bootstrap4/Modal";
import WindReport from "../components/modals/WindReport";

const { RangePicker } = DatePicker;

function ReportLibraryPage(props) {
    var startDate = moment().add(-6, 'days');
    var endDate = moment();
    window.scrollTo(0, 0);//scroll top of the page when click on the report library

    const [start_date, setStartDate] = useState(startDate.format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(endDate.format('YYYY-MM-DD'));
    const [selectedDates, setSelectedDates] = useState([]);
    const [pickedDate, setPickedDate] = useState(new Date());
    const defaultDates = [startDate, endDate];

    const handleInput = (obj) => {
        setStartDate(obj ? obj[0].format('YYYY-MM-DD') : '');
        setEndDate(obj ? obj[1].format('YYYY-MM-DD') : '');
    }

    const disabledDate = (current) => {
        return current && current > moment(new Date(), 'YYY-MM-DD');
    }

    const showFolders = () => {
        function getDates(startDate, stopDate) {
            var dateArray = [];
            var currentDate = moment(startDate);
            var stop_date = moment(stopDate);
            while (currentDate <= stop_date) {
                dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
                currentDate = moment(currentDate).add(1, 'days');
            }
            return dateArray;
        }

        const selectedDates = getDates(start_date, end_date);
        setSelectedDates(selectedDates);
    }

    const clickFolder = (date) => {
        $("#reports").removeClass("hide");
        setPickedDate(date);
    }

    const label = <span className="cursor-pointer text-primary">View <i className="fa fa-angle-right"></i></span>;

    const reports = [{
        name: 'Weather Report',
        description: 'View how the weather was at your site on any selected date.',
        pic: <i name="darksky" className="fa fa-cloud-sun-rain" style={{ color: "rgb(95, 186, 224)" }}></i>,
        report: <Modal ref={React.createRef()} id="weatherReportModal" title="Weather Report" label={label} size="modal-lg"><WeatherReport title="Weather Weekly Report" key={pickedDate} pickedDate={pickedDate}></WeatherReport></Modal>
    },
    {
        name: 'Man Power Report',
        description: 'View how many people were at your site during each hour of a day.',
        pic: <i className="fa fa-users"></i>,
        report: <Modal ref={React.createRef()} id="manPowerReportModal" title="Man Power Report" label={label} size="modal-lg"><HumanPowerReport title="Man Power Report" key={pickedDate} pickedDate={pickedDate}></HumanPowerReport></Modal>
    }, {
        name: 'Standard Daily Report',
        description: 'View consolidated report of site information on any selected date.',
        pic: <i className="fa fa-file-alt text-primary"></i>,
        report: <Modal ref={React.createRef()} id="stdDailyReportModal" title="Standard Daily Report" label={label} size="modal-lg"><StandardDailyReport title="Standard Daily Report" key={pickedDate} hideDatePicker="hide" pickedDate={pickedDate}></StandardDailyReport></Modal>
    }, {
        name: "Environmental Daily Report",
        description: 'View environmental parameters of your site on any selected date.',
        pic: <i className="fa fa-globe-americas text-success"></i>,
        report: <Modal ref={React.createRef()} id="environmentalDailyReportModal" title="Environmental Daily Report" label={label} size="modal-lg"><EnvironmentalReport title="Environmental Daily Report" key={pickedDate} hideDatePicker="hide" pickedDate={pickedDate}></EnvironmentalReport></Modal>
    }, {
        name: "After-Hours Report",
        description: 'View details of after-hours people and vehicles and provide any comments.',
        pic: <i className="fas fa-clock"></i>,
        report: <Modal ref={React.createRef()} id="afterhoursvisitorsreport" title="After Hours Visitors Report" label={label} size="modal-lg"><AfterHoursVisitorsReport title="After Hours Report" key={pickedDate} hideDatePicker="hide" pickedDate={pickedDate}></AfterHoursVisitorsReport></Modal>
    },
    {
        name: "Wind Report",
        description: 'View details of Wind report of your site.',
        pic: <i className='fas fa-wind' style={{ color: "#d9831f" }}></i>,
        report: <Modal ref={React.createRef()} id="windreport" title="Wind Report" label={label} size="modal-lg"><WindReport title="Rain Report" key={pickedDate} hideDatePicker="hide" pickedDate={pickedDate}></WindReport></Modal>
    },
        // {
        //     name: "Vehicle Tracking Report",
        //     description: 'View details of vehicle tracking report of your site.',
        //     pic: <i className="fas fa-car text-primary"></i>,
        //     report: <Modal ref={React.createRef()} id="vehicletrackingreport" title="Vehicle Tracking Report" label={label} size="modal-lg"><VehicleTrackingReport title="Vehicle Tracking Report" key={pickedDate} hideDatePicker="hide" pickedDate={pickedDate}></VehicleTrackingReport></Modal>
        // }
    ];

    return (
        <React.Fragment>
            <div className="page-container" style={{ width: '95%', marginTop: '135px' }}>
                <div className="row mb-1 pl-2">
                    <div className="col-md-12 text-primary">Select Date range to retrieve reports</div>
                </div>
                <div className="row pl-2 mb-2">
                    <div className="col-md-12">
                        <RangePicker disabledDate={disabledDate} defaultValue={defaultDates} onChange={(obj) => handleInput(obj)} />
                        <button id="submitBtn" className="btn btn-sm btn-primary ml-1" disabled={start_date === '' || end_date === ''} onClick={() => showFolders()}>Submit</button>
                    </div>
                </div>
                <div className="row pl-3 pt-3">
                    {selectedDates.map((date, i) =>
                        <button
                            key={i}
                            type="button"
                            className={pickedDate === date ? "btn btn-sm btn-primary text-white m-2" : "btn btn-sm btn-outline-primary text-dark m-2"}
                            onClick={() => clickFolder(date)}><i className="far fa-folder fa-lg"></i> {date}
                        </button>
                    )}
                </div>
            </div>
            <div id="reports" className="hide page-container" style={{ marginTop: '0%' }}>
                <Tiles hideLabel="hide" reports={reports} removeMargin={true}></Tiles>
            </div>
        </React.Fragment>
    );
}

export default ReportLibraryPage;